import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "../context/ContentContext";

export const PageHero = ({ eyebrow, titleKey, subtitleKey, title, subtitle }) => {
  const { c } = useContent();
  return (
    <section className="page-hero">
      <div className="container">
        <Reveal>
          <span className="eyebrow">{eyebrow}</span>
          <h1>{c(titleKey, title)}</h1>
          <p>{c(subtitleKey, subtitle)}</p>
        </Reveal>
      </div>
    </section>
  );
};

export const Reveal = ({ children, delay = 0, className }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 38 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Button = ({ to = "/contact", children, variant = "primary" }) => (
  <Link to={to} className={`btn btn-${variant}`} data-testid={`cta-${String(children).toLowerCase().replace(/[^a-z]+/g, "-")}`}>
    {children} <ArrowUpRight size={16} />
  </Link>
);

export const SectionIntro = ({ eyebrow, title, copy, action }) => (
  <Reveal className="section-intro">
    <div>
      <span className="eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
    </div>
    {(copy || action) && (
      <div className="intro-copy">
        {copy && <p>{copy}</p>}
        {action && <Button to={action.to} variant="secondary">{action.label}</Button>}
      </div>
    )}
  </Reveal>
);

export const CTA = () => {
  const { c } = useContent();
  return (
    <section className="cta-band">
      <div className="container">
        <Reveal className="cta-inner">
          <span className="eyebrow olive">Start a conversation</span>
          <h2>{c("home.cta.title", "What would moving forward look like?")}</h2>
          <Button>Book a Consultation</Button>
        </Reveal>
      </div>
    </section>
  );
};

export const useSeo = (title, description) => {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
};
